import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import { Null } from 'app/src/components/Null';
import type { Category } from './types';

export const LazyBoardsPageTemplatePicker: FunctionComponent<{
  category?: Category;
}> = ({ category = 'popular' }) => {
  const BoardsPageTemplatePicker = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "boards-page-template-picker-container" */ './BoardsPageTemplatePickerContainer'
      ),
    { namedImport: 'BoardsPageTemplatePickerContainer' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Boards Page Template Picker',
      }}
      errorHandlerComponent={Null}
    >
      <Suspense fallback={null}>
        <BoardsPageTemplatePicker category={category} />
      </Suspense>
    </ErrorBoundary>
  );
};
